var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.isOpen,
        width: "90%",
        "append-to-body": "",
        "close-on-click-modal": false,
        footer: null,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [_c("iframe", { staticClass: "view-box", attrs: { src: _vm.src } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }